// extracted by mini-css-extract-plugin
export default {"root":"styles-root-a65f93"};